import { Injectable } from '@angular/core';
import { DropDownListElement } from '../../shared/utility/drop-down-list-element';

@Injectable({
  providedIn: 'root'
})
export class TargetsListHelperService {
  getTargetTypeList(): DropDownListElement[] {
    return [
      { text: 'Assessment' },
      { text: 'Banding' },
      { text: 'Both' }
    ];
  }
}
